'use client';

import Script from "next/script";

// reCAPTCHA v2 invisible: script loads WITHOUT ?render= param.
// The widget is rendered explicitly via grecaptcha.render() in executeCaptcha.
export default function RecaptchaServerScript() {
    return (
        <Script
            src="https://www.google.com/recaptcha/api.js?render=explicit"
            strategy="afterInteractive"
        />
    );
}
